import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { useGetAttractionsFromFirestore, useGetCityDocumentFromFirestore, useQueryHelper } from 'src/queries';
import { useHotelState, useLanguageState, useOrganizationState } from 'src/state';

import { Card, CoverImage, Error, Spinner } from '../../components';
import { Section, Text, Title } from './City.styled';

export const City = () => {
  const { organizationData } = useOrganizationState();
  const { hotelData } = useHotelState();
  const navigate = useNavigate();
  const { language: currentLang } = useLanguageState();
  const cityDocument = useGetCityDocumentFromFirestore(organizationData.city || '');
  const { data: cityData } = cityDocument;
  const { isLoading, isError } = useQueryHelper({
    queries: [
      cityDocument],
  });

  const attractions = useGetAttractionsFromFirestore(cityData?.associated_attractions || []);
  const { data: attractionData, refetch } = attractions;

  const { isLoading: attractionsLoading } = useQueryHelper({
    queries: [
      attractions,
    ],
  });

  if (isLoading || attractionsLoading) {
    return <Spinner global />;
  }

  if (isError) {
    return (<Error errorMessage="Bład pobierania atrakcji" action={refetch} />);
  }

  return (
    <>
      <Helmet>
        <title>Hotelspot | Informacje o mieście</title>
        <meta name="description" content="Hotelspot - informacje o mieście" />
      </Helmet>
      <div className="city_screen">
        {!!cityData && (
          <>
            <Section>
              {!!cityData?.name && (
              <Title>
                {cityData?.name || ''}
              </Title>
              )}
              <CoverImage
                cover={cityData?.coverPhoto || ''}
                logo=""
              />

              {!!cityData?.description && (
                <Text>
                  {cityData?.description[currentLang] || ''}
                </Text>
              )}
            </Section>
            <div className="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4">
              {attractionData && attractionData?.map((attraction) => (
                <Card
                  hotelGeopoint={hotelData.address.geoPoint}
                  attractionGeopoint={attraction?.localization}
                  action={() => navigate(`/attraction/${attraction?.id}`)}
                  key={attraction?.id}
                  image={attraction?.cover_photo}
                  title={attraction?.title[currentLang]}
                />
              ))}
            </div>
          </>
        ) }
      </div>
    </>
  );
};
